import { useCallback } from 'react';
import { banksService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Bank } from '../types';

export function useBanks(
  options?: ResourceQueryOptions
): ResourceState<Bank> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      banksService.getAll(opts) as unknown as Promise<{ data: Bank[]; meta?: any }>,
    []
  );
  return useResourceCollection<Bank>(fetchFn, options);
}

export function useBank(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Bank> {
  const resourceId = id;
  const fetchFn = useCallback(
    (bankId: string | number, opts?: ResourceQueryOptions) =>
      banksService.getById(bankId, opts) as unknown as Promise<Bank>,
    []
  );
  return useResourceById<Bank>(fetchFn, resourceId, options);
}

export function useCreateBank(
  onSuccess?: (data: Bank) => void
): MutationState<Bank> {
  const createFn = useCallback(
    (data: any) => banksService.create(data) as unknown as Promise<Bank>,
    []
  );
  return useCreateResource<Bank>(createFn, onSuccess);
}

export function useUpdateBank(
  onSuccess?: (data: Bank) => void
): MutationState<Bank> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return banksService.update(id, data) as unknown as Promise<Bank>;
    },
    []
  );
  return useUpdateResource<Bank>(updateFn, onSuccess);
}

/**
 * Delete bank using documentId
 * @param data - Full bank object containing documentId
 */
export function useDeleteBank(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return banksService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
